export const getInventoryLocationMenuItems = (inventoryLocations, usedInventoryLocationIds, currentValue) =>
  inventoryLocations?.map(loc => ({
    label: loc.name,
    value: loc.id,
    disabled: usedInventoryLocationIds?.includes(loc.id) && loc.id !== currentValue,
  }))
